module.exports = __webpack_public_path__ + "img/fleet_and_log.a5b5f600.png";